import React from "react";
import { Box, Typography } from "@mui/material";
//import { ArrowOutward } from "@mui/icons-material";


export default function CardHoverCeci({ Image, Titolo, Descrizione, Desc02 }) {

  //const [hover, setHover] = React.useState(true);
  const hover = true;
  function setHover() {}//const [hover, setHover] = React.useState(false);
  
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        borderRadius: "20px",
        overflow: "hidden",
        backgroundImage: `url('/assets/${Image}')`, // <-- sostituisci con il tuo path
        backgroundSize: "cover",
        backgroundPosition: "center",
        transition: "all 0.3s ease",
        cursor: "pointer",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(82, 113, 128, 0.4)", // overlay blu-grigio trasparente
          transition: "background-color 0.3s ease",
        },
        backgroundColor: "rgba(82, 113, 128, 0.6)",
      }}      
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* Titolo */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          //width: "100%",
          zIndex: 2,
          textAlign: "left",
          paddingX: "20px",
          paddingY: "30px"
        }}
      >
        <div
          className="stile-card-titolo bianco sottolinare"
          style={{
            opacity: 1,
            transform: "translateY(0)",
            textDecoration: "underline"
          }}          
        >
          {Titolo}
        </div>
      </Box>

      {/* Descrizione visibile su hover */}
      <Box
        className="description"
        sx={{
          textAlign: "left",
          position: "absolute",
          bottom: 50,
          color: "#FFF",
          fontFamily: "'Barlow', sans-serif",
          fontSize: "1rem",
          transition: "all 0.3s ease",
          zIndex: 2,
          paddingX: "20px",
          opacity: 1,
          transform: "translateY(0)",
        }}
      >
        <div
          className="stile-card-sottotitolo bianco"
        >
          {Descrizione}
          <br/>
          {Desc02}
        </div>
      </Box>


      {/* Freccia in basso a destra */}
{ !hover &&
      <Box
        sx={{
          position: "absolute",
          right: 20,
          bottom: 30,
          zIndex: 2,
        }}
      >
        <svg width="15" height="15" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.9898 16.0199L0.857176 0.857177" stroke="white" stroke-width="1.71436" stroke-linecap="round"/>
          <path d="M15.9898 16.0195L0.857176 16.0195" stroke="white" stroke-width="1.71436" stroke-linecap="round"/>
          <path d="M15.9898 0.857178L15.9898 16.0199" stroke="white" stroke-width="1.71436" stroke-linecap="round"/>
        </svg>
      </Box>
      }
    </Box>
  );
}
